import { render, staticRenderFns } from "./ShareProduct.vue?vue&type=template&id=7d53cd2c"
import script from "./ShareProduct.vue?vue&type=script&lang=js"
export * from "./ShareProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports